import React from 'react';
import meetingState from '../../../../data/constants/meetingState';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import { useMyUserId } from '../../../../data/hooks/sessionHooks';
import meetingState2className from '../../../../misc/meetingState2className';
import EventTime from '../../EventTime';
import Link from '../../Link';
import { getMeetingURL } from '../getMeetingURL';
import MeetingParticipant from './MeetingParticipant/MeetingParticipant';

function GroupMeeting(props) {
    const {className = '', event, meeting} = props,
        i18n = useI18n(),
        userId = useMyUserId(),
        invited = meeting.invited.filter(invitee => invitee.user_id != userId);

    if (meeting.initiator.id != userId) {
        invited.unshift({
            user: meeting.initiator,
            state: meetingState.CONFIRMED,
        });
    }

    return (
        <div className={['meeting', 'group', meetingState2className(meeting._state), className].join(' ')}>
            <div className="time">
                <EventTime event={event} time={meeting.start_local} />
            </div>
            <Link href={getMeetingURL(event.id, meeting.id)}>
                <div className="text">
                    <div className="name">{meeting.name}</div>
                    <div className="location">{meeting.location.name}</div>
                    <div className="username">{i18n['button.group_invite']}</div>
                    <div className={['meetingState', meetingState2className(meeting._state), 'state'].join(' ')}></div>
                </div>
            </Link>
            <div className="button"></div>
            {invited.map((invited, i) => (
                <MeetingParticipant key={i} invite={invited} i18n={i18n} />
            ))}
        </div>
    );
}

export default GroupMeeting;
